const Category = () => (
  <div>
    <button type="button">Check status</button>
  </div>
);

export default Category;
